const block = $(".block-news-filter");
const gridResults = $(".block-news-grid");
const firstPage = $(".news-first-page");
const ajaxPosts = $("#ajax-posts");
const searchForm = $("#search-form-box");
const searchInput = $("#NewsSearchInput");

const filterState = {
  action: "get_filtered_news",
  post_type: ["threatx_news"],
  search_value: "",
  filters: {
    category: [],
    post_tag: [],
    news_type: [],
  },
};
const filterLists = $("ul.select-filter-list > li");

const updateNewsTaxonomy = async (tax, value) => {
  $(".main-news").fadeOut();

  $(".news-pagination").fadeOut();
  console.log("tax:", tax);
  console.log("value:", value);
  if (filterState.filters[tax].includes(value)) {
    filterState.filters[tax] = filterState.filters[tax].filter(
      (item) => item !== value
    );
  } else {
    filterState.filters[tax].push(value);
  }
  console.log(filterState.filters);
  console.log(filterState);
  const response = await requestResource();
  console.log("response: ", response);
  displayResources(response);
};

const handleFilterList = () => {
  filterLists.on("click", ({ delegateTarget }) => {
    console.log(".filterLists.length: ", filterLists.length);
    const self = $(delegateTarget);
    self.toggleClass("active");
    const selectedValue = self.data("value");
    const selectedTaxonomy = self.data("filter-by");
    console.log(selectedTaxonomy);
    console.log(selectedValue);
    updateNewsTaxonomy(selectedTaxonomy, selectedValue);
  });
};

const firstResources = $("#ajax-posts > div").slice(0, 6);
const lastResources = $("#ajax-posts > div").slice(6, 12);

const firstGrid = firstPage.find(
  ".first-grid > .container-fluid > .grid-3-columns"
);
const secondGrid = firstPage.find(
  ".second-grid > .container-fluid > .grid-3-columns"
);

const buildFirstPage = () => {
  firstGrid.append(firstResources);
  secondGrid.append(lastResources);
};
const requestResource = async () => {
  let result;
  try {
    result = await $.ajax({
      type: "post",
      url: "/wp-admin/admin-ajax.php",
      data: filterState,
    });
    console.log(result.data);
    return result.data;
  } catch (err) {
    console.error(err);
  }
};

const createHTMLElement = ({
  link,
  title,
  taxName,
  catURL,
  excerpt,
  tagColor,
  thumbnail,
  time,
}) => {
  return `
    <div class="col-md-12">
      <div class="job">
        <div class="job-image news-image has-thumbnail">
          <img src="${thumbnail}" class="img-fluid" alt="">
        </div>
        <div class="job-description">
          <a href="" class="no-styles"></a>
          <div>
            <div class="job-meta">
              <a class="tag ${tagColor} job-tag text-uppercase" target="_blank"
                href="${catURL}">
                <span>
                  ${taxName}
                </span>
              </a>
              <div class="job-location">
                ${time}
              </div>
            </div>

            <h4>
              <a href="${link}">
                ${title}
              </a>
            </h4>

            <div class="job-text">
              ${excerpt}
            </div>
            <a href="${link}" target="_blank" class="link-w-arrow">View More</a>
          </div>
        </div>
      </div>
    </div>
  `;
};
const displayResources = (resources) => {
  if (!resources) return;

  const allResources = resources
    .map((resource) => createHTMLElement(resource))
    .join("");
  $("#pagination").empty();
  if (firstPage.length) {
    firstPage.hide();
  }
  gridResults.show();
  $("#ajax-posts").empty().append(allResources).show();
};

const News = () => {
  if (block.length) {
    const select = block.find(".select-filter > button");
    select.on("click", ({ delegateTarget }) => {
      const self = $(delegateTarget);
      const parent = self.parent();
      const siblings = parent.siblings();
      siblings.removeClass("active");
      parent.toggleClass("active");
      //close filters when clicking outside
      $(document).mouseup(function (e) {
        var container = $(".select-filter-list");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.hide();
        }
      });
    });

    // Listener for search input
    searchInput.on("input", ({ delegateTarget }) => {
      const self = $(delegateTarget);
      const query = self.val();
      if (query.length > 3) {
        filterState["search_value"] = query;
        console.log(filterState);
      }
    });

    searchForm.on("submit", async (event) => {
      console.log("what a wonderful world");
      $(".card-resource--featured").fadeOut(function () {
        $(".block-resources-hero .block-layer-1").css({ height: "793px" });
      });
      $(".news-pagination").fadeOut();
      event.preventDefault();

      const response = await requestResource();
      console.log("response on submit: ", response);
      displayResources(response);
    });

    handleFilterList();
  }
  if (firstPage.length) {
    ajaxPosts.hide();
    buildFirstPage();
    firstPage.show();
  } else {
    ajaxPosts.show();
  }

  $("#pagination-blog").on("click", "a", function (e) {
    e.preventDefault();
    $(this).remove();
    const url = $(this).attr("href");

    $("#ajax-loader").load(url + " #ajax-posts>*", () => {
      history.pushState({}, "", url);
      $(".second-grid .grid-3-columns").append($("#ajax-loader > *"));
    });
    $("#pagination-blog").load($(this).attr("href") + " #pagination-blog>*");
  });
};

export default {
  init() {
    News();
    const pagination = $("#news-pagination");
    const ajaxPosts = $("#ajax-posts");

    const getPosts = (response) => {
      return $(response).find("#ajax-posts > div");
    };

    const getNextPagination = (response) => {
      return $(response).find("#news-pagination");
    };

    const request = async (url) => {
      let result;
      try {
        result = await $.ajax({
          type: "GET",
          url,
        });
        return result;
      } catch (err) {
        console.error(err);
      }
    };

    const handleClick = async (e) => {
      e.preventDefault();
      const url = $(e.target).attr("href");
      const response = await request(url);
      ajaxPosts.append(getPosts(response));
      pagination.empty().append(getNextPagination(response));
    };
    pagination.on("click", "a", (e) => handleClick(e));
  },
};
